export const AdminBoardData = [
    {name: 'Getting Started'},
    {name: 'Course Portal', url:'courseupload'},
    {name:'Promo Codes' , url:'promocode'} ,
    {name:'Projects' , url:'projects'} ,
    {name: 'Course Landing Component' , url:'courselanding'}

];